export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f60cdf85cf4de74eb2c396b4210819aa079c881bd&name=fetchTypeahead!'